import React, { useEffect, useState } from "react";
import api, { formatTanggal } from "@/lib/api";
import Layout, { PageTitle } from "@/components/Layout";
import { NAV_ORTU } from "@/lib/nav";
import { Megaphone } from "lucide-react";

export function PemberitahuanOrtu() {
  const [items, setItems] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/pemberitahuan"); setItems(data); })(); }, []);
  return (
    <Layout nav={NAV_ORTU}>
      <PageTitle title="Pemberitahuan" />
      <section className="space-y-3">
        {items.length === 0 && <div className="pp-card p-10 text-center italic text-slate-400">Belum ada pemberitahuan.</div>}
        {items.map(p => (
          <div key={p.id} className="pp-card p-5">
            <div className="flex items-center gap-2 mb-2"><Megaphone className="w-4 h-4 text-indigo-600" /><span className="text-xs text-slate-500">{formatTanggal(p.created_at)} — {p.posted_by_nama}</span></div>
            <p className="text-slate-800 whitespace-pre-wrap">{p.isi}</p>
          </div>
        ))}
      </section>
    </Layout>
  );
}
